import { Link } from 'react-router-dom';

function AdminHeader({ handleLogout }) {
  return (
    <header className="sticky top-0 z-20 border-b border-[#18322814] bg-[rgba(244,239,230,0.88)] backdrop-blur">
      <div className="mx-auto flex w-[min(1180px,calc(100%-40px))] items-center justify-between py-4">
        <div>
          <p className="m-0 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">OmsorgBygg admin</p>
          <h1 className="font-serif text-2xl font-semibold text-[#163127]">Dashboard og innholdsadministrasjon</h1>
        </div>
        <div className="flex items-center gap-4">
          <Link className="text-sm font-semibold text-[#355046] no-underline" to="/">
            Se offentlig side
          </Link>
          <button className="rounded-full border border-[#1832281f] bg-white px-4 py-2 font-semibold text-[#355046]" onClick={handleLogout} type="button">
            Logg ut
          </button>
        </div>
      </div>
    </header>
  );
}

export default AdminHeader;